import * as React from 'react';
import CardSection from '../../common/CardSection';

class DocumentsPage extends React.Component<{}> {
    public render() {
        return <CardSection title="Documents" />;
    }
}

export default DocumentsPage;



// WEBPACK FOOTER //
// ./src/components/project/sections/Documents.tsx